import React from 'react'

import { Wrapper } from 'components'

import './account-footer.scss'

const AccountFooter = ( props: object ) => <Wrapper {...props} extraClassName='account-footer' />

export default AccountFooter
